import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
//import GameWindow from './gameWindow';
import Menu from './menu';

ReactDOM.render(
  <Menu />,
  document.getElementById('root')
);
